import moment from 'moment';

export interface DaterangeISO {
  start: string;
  end: string;
}

export interface SelectedDateRange {
  start: moment.Moment;
  end: moment.Moment;
}

export interface DSTStatus {
  hasDSTTransition: boolean;
  type: 'spring_forward' | 'fall_back' | null;
}


export type DateTimeOfDay = 'am' | 'pm';

export enum DateKindEnum{
  start = 'START',
  end = 'END'
}